import styled from 'styled-components';
import {
  SomeUserNameInitials,
  numberInRange
} from '../helpers/helperFunctions';
import { useWindowWide } from '../helpers/wideScreen';
import { H2, H3, H5, P2, P3 } from './FontStyles';
import { colors } from './GlobalStyles';
import { Icon, IconArrowPolygon, IconChevron } from './Icons';
import { DisableSelection } from './stylesStyled';

export const Box = styled.div<any>`
  width: 100%;
  background: ${({ theme }) => theme.colors.neutral50};
  ${({ theme, blue }) => blue && `background:${theme.colors.secondaryBlue}`};
  ${({ theme, gray }) => gray && ` background:${theme.colors.neutral100}`};
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  border: 1px solid ${({ theme }) => theme.colors.neutral100};
  border-radius: ${({ br }) => (br ? br : ' 15px')};
  padding: ${({ theme }) => theme.sizes.s5}px;
  margin-bottom: ${({ theme }) => theme.sizes.s6}px;

  ${({ dark, theme }) =>
    dark &&
    `
      border-radius: 15px;
      background: ${theme.colors.neutral900};
      border: none;
  `}

  ${({ border, theme }) =>
    border &&
    `
      border-radius: 15px;
      border: 1px solid ${theme.colors.neutral900};
      box-shadow: none;
      padding: 10px 20px;
      margin-bottom: 20px;

  `}

padding: ${({ p }) => p};
  background: ${({ bg }) => bg};
  border: ${({ border }) => border};
  box-shadow: ${({ boxShadow }) => boxShadow};

  ${({ p }) => p && `padding: ${p}`};
  ${({ m }) => m && `margin: ${m}`};
  ${({ mt }) => mt && `margin-top: ${mt}px`};
  ${({ mb }) => mb && `margin-bottom: ${mb}px`};
  ${({ ml }) => ml && `margin-left: ${ml}px`};
  ${({ mr }) => mr && `margin-right: ${mr}px`};

  @media (max-width: 800px) {
    padding: ${({ theme }) => theme.sizes.s6}px;
    margin-bottom: ${({ theme }) => theme.sizes.s5}px;

    ${({ pSM }) => pSM && pSM};
    ${({ mSM }) => mSM && mSM};
    ${({ mtSM }) => mtSM && `${mtSM}px`};
    ${({ mbSM }) => mbSM && `${mbSM}px`};
    ${({ mlSM }) => mlSM && `${mlSM}px`};
    ${({ mrSM }) => mrSM && `${mrSM}px`};
  }

  @media (max-width: 345px) {
    padding: ${({ theme }) => theme.sizes.s4}px;
  }
`;

export const Hr = styled.div<any>`
  background: ${(props) => props.theme.colors.neutral100};
  height: 1px;
  width: 100%;
  margin: ${(props) => (props.margin ? props.margin : '40px 0')};
`;

export const SectionSeparator = styled.div<any>`
  margin: ${(props) => (props.margin ? props.margin : '20px 0')};
  width: 100%;
  height: 1px !important;
  /* background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    ${(props) => props.theme.colors.secondary100}30 50%,
    rgba(0, 0, 0, 0) 100%
  ); */

  background: ${(props) => props.theme.colors.neutral200};

  flex: none;
`;

export const SectionSeparatorVertical = styled.div<any>`
  flex: none;
  width: 1px !important;
  height: auto;
  margin: ${(props) => (props.margin ? props.margin : '0 50px')};
  /* background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    ${(props) => props.theme.colors.secondary100}30 50%,
    rgba(0, 0, 0, 0) 100%
  ); */
  /* background: ${(props) => props.theme.colors.secondary100}30; */
`;
export const SecurityCodeWrapper = styled.div<any>`
  .react-code-input {
    width: 100% !important;
    display: flex !important;
    align-items: center !important;
    gap: 7px !important;
    margin: 10px 0 !important;
    font-family: 'Rubik' !important;
    @media (max-width: 345px) {
      gap: 5px !important;
    }

    > * {
      flex-grow: 1 !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      height: 60px !important;
      padding-left: none !important;
      background-color: none !important;
      color: ${({ theme }) => theme.colors.primary900} !important;
      border: 2px solid ${({ theme }) => theme.colors.neutral400} !important;
      border-radius: 8px !important;
      font-size: 24px !important;
      text-align: center !important;
      box-shadow: none !important;
      margin: 0 !important;
      padding: 0 !important;
      font-family: 'Rubik' !important;

      ${({ is2Fa }) =>
        is2Fa &&
        `
        :nth-child(3) {
        margin-right: 20px !important;
      @media (max-width: 345px) {
        margin-right: 15px !important;

      }
      }
      `}

      :focus {
        border: 2px solid ${({ theme }) => theme.colors.primary900} !important;
      }

      @media (max-width: 345px) {
        font-size: 20px !important;
        height: 50px !important;
      }
    }
  }
`;
//////////////
// BUTTON

export const Button = styled.button<any>`
  border: none;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  height: 54px;
  border-radius: 100px;
  width: ${({ w }) => (w ? w : '100%')};
  cursor: pointer;
  font-size: ${(props) => props.theme.buttonFontSize};

  color: ${(props) => props.theme.colors.neutral0};
  ${({ color }) => color && `background-color: ${color}`};

  ${(props) => props.textColor && `color: ${props.textColor};`}

  background: ${(props) =>
    props.negative ? 'none' : props.theme.buttonBackground};
  border: ${(props) =>
    props.negative ? `1px solid ${props.theme.colors.neutral900}` : 'none'};

  ${(props) => props.disabled && `opacity: 0.5;`}
  ${(props) => props.disabled && `cursor: not-allowed`};

  ${(props) => props.fs && `font-size: ${props.fs}`};

  ${({ color }) => color && `background-color: ${color}`};

  height: ${(props) => props.h};
  padding: ${(props) => props.p};

  margin: ${(props) => props.m};
  margin-top: ${(props) => props.mt}px;
  margin-bottom: ${(props) => props.mb}px;
  margin-left: ${(props) => props.ml}px;
  margin-right: ${(props) => props.mr}px;

  max-width: ${(props) => props.maxWidth};

  ${({ condensed }) =>
    condensed &&
    `
    height: 33px; 

  `}

  ${({ negativeLight, theme }) =>
    negativeLight &&
    `
    border: 1px solid ${theme.colors.neutral0};
    color: ${theme.colors.neutral0};
    background: none;

  `}

  @media (max-width: 800px) {
    margin: ${(props) => props.mSM};
    margin-top: ${(props) => props.mtSM}px;
    margin-bottom: ${(props) => props.mbSM}px;
    margin-left: ${(props) => props.mlSM}px;
    margin-right: ${(props) => props.mrSM}px;

    max-width: ${(props) => props.maxWidthSM};
    width: ${(props) => (props.wSM ? props.wSM : '100%')};
  }

  ${({ textButton, theme }) =>
    textButton &&
    `
    background-color: rgba(0,0,0,0);
    color: ${theme.colors.neutral900};
    font-weight: 700;
    border: none;
  `}

  transition: transform 0.1s ease, background-color 0.3s ease, border 0.3s ease,
    color 0.3s ease;

  :active {
    transform: translateY(3px);
  }
  > * {
    ${DisableSelection}
  }
`;

export const BrowseFilesButton = styled.label<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  font-size: 15px;
  color: #fff;
  height: 44px;
  width: 100%;
  cursor: pointer;

  font-size: ${(props) => props.theme.buttonFontSize};

  color: ${(props) =>
    props.negative
      ? props.theme.buttonNegativeFontColor
      : props.theme.buttonFontColor};

  background-color: ${(props) =>
    props.negative
      ? props.theme.buttonNegativeBackground
      : props.theme.buttonBackground};

  border: ${(props) =>
    props.negative
      ? props.theme.buttonNegativeBorder
      : props.theme.buttonBorder};

  ${(props) =>
    props.disabled && `color: ${props.theme.buttonDisabledFontColor};`}

  ${(props) =>
    props.disabled && `background: ${props.theme.buttonDisabledBackground};`}

  ${(props) => props.disabled && `border: ${props.theme.buttonDisabledBorder};`}

  ${(props) => props.disabled && `cursor: not-allowed`};

  ${(props) => props.fs && `font-size: ${props.fs}`};

  /* opacity: ${(props) => (!props.opacity ? '1' : '0.5')}; */
  /* cursor: ${(props) => (!props.opacity ? 'default' : 'pointer')}; */
  border-radius: ${(props) => props.theme.buttonBorderRadius};

  height: ${(props) => props.h};

  margin: ${(props) => props.m};
  margin-top: ${(props) => props.mt}px;
  margin-bottom: ${(props) => props.mb}px;
  margin-left: ${(props) => props.ml}px;
  margin-right: ${(props) => props.mr}px;

  max-width: ${(props) => props.maxWidth};

  @media (max-width: 800px) {
    margin: ${(props) => props.mSM};
    margin-top: ${(props) => props.mtSM}px;
    margin-bottom: ${(props) => props.mbSM}px;
    margin-left: ${(props) => props.mlSM}px;
    margin-right: ${(props) => props.mrSM}px;

    max-width: ${(props) => props.maxWidthSM};
  }

  transition: transform 0.1s ease, background-color 0.3s ease, border 0.3s ease,
    color 0.3s ease;

  :active {
    transform: translateY(3px);
  }
  > * {
    ${DisableSelection}
  }
`;

export const Table = styled.table`
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  background: ${(props) => props.theme.colors.neutral0};
  /* border: 1px solid ${({ theme }) => theme.colors.neutral100}; */
  width: 100%;
  margin-bottom: 24px;
  border-radius: 12px;
  border-collapse: collapse;
  border-style: hidden;
  overflow: hidden;

  thead {
    background-color: ${({ theme }) => theme.colors.primary900};
    color: ${({ theme }) => theme.colors.neutral0};
    div {
      color: ${({ theme }) => theme.colors.neutral0};
    }
  }

  thead tr th {
    text-transform: uppercase;
  }

  tbody tr td {
    border-collapse: collapse;
    border: 1px solid ${(props) => props.theme.colors.neutral400}80;
  }

  tbody tr:last-child td {
    box-shadow: none;
  }

  > * {
    border-collapse: collapse;
  }

  th {
    padding: 0;
    height: 60px;
  }

  td {
    height: 55px;
    padding: 0;
    text-align: center;
  }

  /* .colored {
    background-color: ${({ theme }) => theme.colors.primary900};
    > div {
      color: ${({ theme }) => theme.colors.neutral0};
    }
  } */

  @media (max-width: 800px) {
    tbody tr td > div {
      font-size: 13px;
    }

    thead tr th > div {
      font-size: 14px;
    }
  }

  @media (max-width: 380px) {
    tbody tr td > div {
      font-size: 10px;
    }

    thead tr th > div {
      font-size: 12px;
    }
  }
`;

export const BoxMobile = styled.div<any>`
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  background: ${(props) => props.theme.colors.neutral50};
  margin-bottom: 12px;
  border-radius: 12px;
  padding: 12px;
  width: 100%;
`;

//////////////
// PROGRESS BAR

export const ProgressBar = styled.div<any>`
  position: relative;
  width: 100%;
  padding: 2px 3px;
  background: ${(props) => props.theme.colors.neutral100};
  border: 1px solid rgba(45, 45, 45, 0.02);
  box-sizing: border-box;
  border-radius: 100px;
  overflow: hidden;
  div {
    width: ${(props) => (props.percentage ? props.percentage : 0)};
    height: 8px;
    background: ${({ theme, progressColor }) =>
      progressColor ? progressColor : theme.colors.primary900};
    border-radius: 100px;
  }

  ${({ percentageLabel }) =>
    percentageLabel &&
    `
    span {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-weight: 500;
      font-size: 20px;
    }
    div {
      height: 30px;
    }

  `}
`;

// PROGRESS BAR with percentage

export const ProgressBarWithPercentage = styled.div<any>`
  width: 100%;
  /* padding: 2px 3px; */
  background: ${(props) => props.theme.colors.neutral100};
  border: 1px solid rgba(45, 45, 45, 0.02);
  box-sizing: border-box;
  border-radius: 13px;
  margin-bottom: 20px;
  height: 12px;
  > div {
    position: relative;
    width: ${(props) =>
      props.percentage ? `${props.percentage + '%'}` : '0%'};
    height: 12px;
    background: ${(props) => props.color};
    border-radius: 6px;
    > div {
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: -7px;
      border: 2px solid ${(props) => props.color};
      box-shadow: ${(props) => props.color};
      background: ${(props) => props.theme.colors.neutral50};
      color: ${(props) => props.color};
      border-radius: 9px;
      white-space: nowrap;
      flex: none;
      padding: 0 5px;
      height: 26px;
      font-weight: 500;
      font-size: 10px;
      line-height: 140%;
      ${({ percentage, progressWidth, progressValueWidth }) =>
        percentageBoxPosition(percentage, progressWidth, progressValueWidth)};
    }
  }
`;

export const percentageBoxPosition = (
  percentage: any,
  progressWidth: any,
  progressValueWidth: any
) => {
  if (numberInRange(percentage, 0, 10)) {
    if (progressWidth >= progressValueWidth) {
      return 'right: -20px;';
    } else {
      return 'left: 0;';
    }
  }

  if (numberInRange(percentage, 11, 69)) return 'right: -20px;';
  if (numberInRange(percentage, 70, 101)) return 'right: 0;';
};

export const ArrowPolygon = ({ direction, customColor }: any) => {
  return (
    <ArrowPolygonStyle direction={direction}>
      <Icon color={customColor ?? colors.secondary100}>
        <IconArrowPolygon />
      </Icon>
    </ArrowPolygonStyle>
  );
};

export const ArrowChevron = ({ direction, customColor }: any) => {
  return (
    <ArrowPolygonStyle direction={direction}>
      <Icon color={customColor ?? colors.secondary100}>
        <IconChevron />
      </Icon>
    </ArrowPolygonStyle>
  );
};

export const ArrowPolygonStyle = styled.div<any>`
  transition: transform 0.3s ease;
  transform: ${(props) => {
    if (props.direction === 'up') {
      return 'rotate(180deg);';
    } else if (props.direction === 'down') {
      return '';
    } else if (props.direction === 'left') {
      return 'rotate(180deg);';
    } else if (props.direction === 'right') {
      return 'rotate(-90deg);';
    }
  }};
`;

/////////////////////////
// SELECT INPUT PLACEHOLDER

export const Select = styled.div<any>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(props) => props.theme.inputBackground};
  border-radius: ${(props) => props.theme.buttonBorderRadius};
  width: ${(props) => (props.w ? props.w : '100%')};
  ${(props) => props.maxWidth && `max-width: ${props.maxWidth}`};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};

  height: ${(props) => props.theme.inputHeight};
  padding: ${(props) => (props.padding ? props.padding : '0 20px')};
  border: ${(props) => props.theme.inputBorder};
  box-shadow: ${(props) => props.theme.inputShadow};

  font-size: ${(props) => props.theme.inputFontSize};
  color: ${(props) => props.theme.inputFontColor};

  margin: 0 0 20px 0;
  margin: ${(props) => props.m};
  margin-top: ${(props) => props.mt}px;
  margin-bottom: ${(props) => props.mb}px;
  margin-left: ${(props) => props.ml}px;
  margin-right: ${(props) => props.mr}px;

  span img {
    width: 14px;
    margin-right: 10px;
  }
`;

///////////////
//TABS & TABS BUTTON

export const Tabs = styled.div<any>`
  overflow-y: auto;
  display: flex;
  align-items: center;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const TabSelectButton = styled.div<any>`
  > div {
    background: ${(props) =>
      props.selected
        ? props.light
          ? props.theme.tabs.backgroundSelectedLight
          : props.theme.tabs.backgroundSelected
        : props.theme.tabs.background};
    border-radius: 100px;
    padding: 0 24px;
    height: 43px;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
  }
  background: ${(props) =>
    props.selected
      ? props.theme.tabs.borderColorSelected
      : props.theme.tabs.borderColor};
  padding: 1px;
  flex: none;
  color: ${(props) =>
    props.selected ? props.theme.tabs.colorSelected : props.theme.tabs.color};
  font-size: 18px;
  line-height: 20px;
  font-weight: 700;
  border-radius: 100px;
  margin-right: 20px;
  margin-bottom: 20px;

  border: ${(props) =>
    props.selected ? 'none' : '1px solid ' + props.theme.colors.neutral900};
  ${(props) => props.m && `margin: ${props.m}`};

  cursor: pointer;
  transition: all 0.2s ease;

  @media (max-width: 800px) {
    margin-right: 8px;
  }
`;

///////////////
//TABS & TABS BUTTON
export const ToggleTabs = styled.div<any>`
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(props) => props.theme.toggleTabs.wrapper};
  border-radius: 8px;
  margin-bottom: 20px;
  overflow-x: auto;
  z-index: 1;
`;

export const ToggleTabButton = styled.div<any>`
  width: 100%;
  justify-content: center;
  cursor: pointer;
  height: 38px;
  display: flex;
  align-items: center;
  text-align: center;
  padding: 0 10px;
  background: ${(props) => props.theme.toggleTabs.background};
  box-sizing: border-box;
  border-radius: 8px;
  color: ${(props) =>
    props.selected
      ? props.theme.colors.neutral0
      : props.theme.colors.neutral900};
  background: ${(props) =>
    props.selected ? props.theme.toggleTabs.backgroundSelected : 'none'};
  transition: all 0.2s ease;

  @media (max-width: 360px) {
    font-size: 14px;
  }
`;

export const AuthLayoutTitle = ({ children }: any) => {
  return (
    <H3 mb='10' center color={colors.neutral900}>
      {children}
    </H3>
  );
};

export const AuthLayoutSubTitle = ({ children, ...props }: any) => {
  return (
    <P3 mb='50' center color={colors.neutral900} {...props}>
      {children}
    </P3>
  );
};

export const PageTitle = ({ children, ...props }: any) => {
  const wide = useWindowWide(800);
  if (wide) {
    return (
      <H2 m='24px 0' color={colors.neutral900} {...props}>
        {children}
      </H2>
    );
  } else {
    return (
      <H3 m='20px 0' color={colors.neutral900} {...props}>
        {children}
      </H3>
    );
  }
};

export const View = styled.div<any>`
  margin: 20px 0;
  min-height: 640px;
  padding-bottom: 70px;
  position: relative;
  width: 100%;

  @media (min-width: 800px) {
    max-width: 1500px;
    padding: 0 100px;
  }

  @media only screen and (max-width: 1500px) and (min-width: 800px) {
    zoom: 80%;
  }
`;

////////////////
//USER IMAGE

export const ProfilePicture = styled.div<any>`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => (props.size ? props.size : '102px')};
  width: ${(props) => (props.size ? props.size : '102px')};
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;

  ${DisableSelection}
`;

export const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  ${DisableSelection};
`;

export const ProfileImagePlaceholder = styled.div<any>`
  font-size: ${(props) => (props.font ? props.font : '102px')};
  color: ${(props) => props.theme.colors.neutral0};
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    !props.disabled
      ? props.theme.colors.secondary100
      : props.theme.colors.neutral100};
  height: ${(props) => (props.size ? props.size : '102px')};
  width: ${(props) => (props.size ? props.size : '102px')};
  border-radius: 50%;

  @media (max-width: 800px) {
    font-weight: 600;
  }
`;

export const UserImageCircle = ({
  image,
  name,
  surname,
  size,
  margin,
  fontSize,
  avatarSize,
  avatar,
  disabled
}: any) => {
  return (
    <ProfilePicture
      size={size ? size : '56px'}
      style={{
        margin: margin
      }}>
      {image ? (
        <ProfileImage src={image} alt='Upload' />
      ) : (
        <ProfileImagePlaceholder
          disabled={disabled}
          size={size ? size : '56px'}
          font={fontSize}>
          {avatar ? (
            <Icon color={!disabled ? colors.neutral900 : colors.neutral400}>
              <svg
                width={avatarSize ?? '24px'}
                height={avatarSize ?? '25px'}
                viewBox='0 0 24 25'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M11.9999 12.0631C15.3138 12.0631 18.0002 9.3767 18.0002 6.06286C18.0002 2.74902 15.3138 0.0626221 11.9999 0.0626221C8.68608 0.0626221 5.99968 2.74902 5.99968 6.06286C5.99968 9.3767 8.68608 12.0631 11.9999 12.0631Z'
                  fill='#8B8CFE'
                />
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M12.0005 13.5626C7.99532 13.5626 0 15.5727 0 19.5628V22.5629C0 23.388 0.675027 24.063 1.50006 24.063H22.5009C23.3259 24.063 24.001 23.388 24.001 22.5629V19.5628C24.001 15.5727 16.0056 13.5626 12.0005 13.5626Z'
                  fill='#8B8CFE'
                />
              </svg>
            </Icon>
          ) : (
            SomeUserNameInitials(name ?? '-', surname ?? '-')
          )}
        </ProfileImagePlaceholder>
      )}
    </ProfilePicture>
  );
};

export const PackageList = styled.div<any>`
  width: 310px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 800px) {
    margin-bottom: 15px;
  }
`;
//////////////////

export const Flexed = styled.div<any>`
  display: flex;
  ${(props) => props.between && 'justify-content: space-between'};
  ${(props) => props.end && 'justify-content: end'};
  ${(props) => props.justifyCenter && 'justify-content: center'};
  ${(props) => props.center && 'align-items: center'};
  ${(props) => props.alignStart && 'align-items:  flex-start'};
  ${(props) => props.alignEnd && 'align-items:  flex-end'};

  ${(props) => props.column && 'flex-direction: column'};
  ${(props) => props.gap && `gap:${props.gap}`};
  ${(props) => props.pointer && `cursor: pointer`};
  ${(props) => props.wrap && `flex-wrap: wrap`};
  ${(props) => props.grow && `flex-grow:${props.grow}`};
  ${(props) => props.flexNone && `flex: none`};
  ${(props) => props.wrap && `flex-wrap: wrap`};
  ${(props) => props.spaceAround && `justify-content: space-around`};

  margin: ${(props) => props.m};
  margin-top: ${(props) => props.mt}px;
  margin-bottom: ${(props) => props.mb}px;
  margin-left: ${(props) => props.ml}px;
  margin-right: ${(props) => props.mr}px;
  gap: ${(props) => props.gap}rem;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  ${(props) => props.position && 'position:' + props.position};

  @media (max-width: 800px) {
    ${(props) => props.rowSM && 'flex-direction: column'};
    ${(props) => props.alignStartSM && 'align-items: start'};
    ${(props) => props.betweenSM && 'justify-content: space-between'};

    ${(props) => props.gapSM && `gap: ${props.gapSM}`};
    margin: ${(props) => props.mSM};
    margin-top: ${(props) => props.mtSM}px;
    margin-bottom: ${(props) => props.mbSM}px;
    margin-left: ${(props) => props.mlSM}px;
    margin-right: ${(props) => props.mrSM}px;
    width: ${(props) => props.widthSM};
    height: ${(props) => props.heightSM};
    max-width: ${(props) => props.maxWidthSM};
  }

  ${({ desktop }) =>
    desktop &&
    `
    @media (max-width: 800px) {
    display: none;
  }

  `};

  ${({ mobile }) =>
    mobile &&
    `
    @media (min-width: 800px) {
    display: none;
  }
  
  `}
`;

export const EarningBox = styled.div<any>`
  width: 100%;
  padding: 15px;
  border-radius: 15px;
  background: ${(props) => props.theme.colors.neutral0};
  margin-bottom: 15px;
  box-shadow: ${(props) => props.theme.shadows.shadowXS};
  ${(props) => (props.pointer ? 'cursor: pointer' : '')};
`;

export const CookieOverlay = styled.div<any>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.neutral50}e5;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
`;

export const FloatingButton = styled.div<any>`
  position: relative;
  z-index: 2;

  @media (max-width: 800px) {
    position: fixed;
    left: 0px;
    right: 0px;
    bottom: 0px;
    padding: 40px 20px 20px 20px;
    background: ${({ theme }) =>
      `linear-gradient( 0deg, ${theme.colors.neutral50} 40%, ${theme.colors.neutral50}00 100%)`};

    button {
      width: 100% !important;
      max-width: 100% !important;
    }
  }
`;

export const TermsWrapper = styled.div<any>`
  margin-bottom: 40px;
  padding: 30px 0;
  border-top: 1.5px solid ${({ theme }) => theme.colors.neutral900};
  border-bottom: 1.5px solid ${({ theme }) => theme.colors.neutral900};

  > div {
    height: ${({ height }) => (height ? height : 'calc(100vh - 600px)')};
    overflow-y: scroll;
    padding-right: 20px;
    padding-bottom: 20px;

    @media (max-width: 1450px) {
      height: calc(100vh - 650px);
    }

    /* width */
    ::-webkit-scrollbar {
      cursor: pointer;
      width: 5px;
      height: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.colors.neutral400};
      border-radius: 20px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.primary900};
      border-radius: 20px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${({ theme }) => theme.colors.primary900};
    }
  }
`;

export const CheckIconBox = styled.div<any>`
  width: ${(props) => (props.width ? props.width : '20px')};
  height: ${(props) => (props.height ? props.height : '20px')};
  background: ${(props) =>
    props.background
      ? props.theme.colors.neutral10
      : props.theme.colors.secondary100};
  border-radius: ${(props) => (props.radius ? props.props.radius : '50%')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
`;

export const CircleIconWrapper = styled.div<any>`
  width: ${(props) => (props.width ? props.width : '45px')};
  height: ${(props) => (props.height ? props.height : '45px')};
  background: ${(props) => props.color};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${(props) => (props.mb ? props.mb : '0px')};
`;

export const Pill = styled.div<{ color?: string }>`
  background: ${(props) => props.color ?? props.theme.colors.secondaryBlue};
  border-radius: 100px;
  padding: 10px;
  text-transform: uppercase;
  font-size: 12px;
  line-height: 140%;
  display: inline-flex;
  color: ${({ theme }) => theme.colors.neutral0};
  font-size: 14px;
  min-width: 100px;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    font-size: 12px;
    min-width: 80px;
    padding: 5px;
  }
`;

export const Collapsable = styled.div<any>`
  opacity: ${(props) => (props.expanded ? '1' : '0')};
  visibility: ${(props) => (props.expanded ? 'visible' : 'hidden')};
  max-height: ${({ expanded, elementHeight }) =>
    expanded ? `${elementHeight}px` : '0px'};
  margin-top: ${(props) => (props.expanded ? '20px' : '0px')};
  overflow: hidden;
  transition: all 300ms;

  @media (min-width: 3500px) {
    margin-top: ${(props) => (props.expanded ? '40px' : '0px')};
  }

  @media (max-width: 800px) {
    margin-top: ${(props) => (props.expanded ? '10px' : '0px')};
  }
`;

export const SelectedUSDT = styled.div`
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 50px;

  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.color
      ? props.theme.colors.neutral500
      : props.theme.colors.neutral900};
  border-radius: 30px;
  padding: 0 20px;
  background: ${(props) => props.theme.colors.neutral100};
`;

export const SelectNetwork = styled.div<{ isOpen: boolean }>`
  margin-bottom: 20px;
  width: 100%;
  padding: 1px;
  border-radius: 8px;
  position: relative;

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 60px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.colors.neutral900};
    border-radius: 8px;
    padding: 0 16px;
    background: ${(props) => props.theme.colors.neutral100};
    > img {
      margin-left: 16px;
      transform: ${(props) => (props.isOpen ? 'rotate(90deg)' : '')};
      transition: all 300ms ease;
    }
  }
`;

export const SelectDropDown = styled.div`
  width: 100%;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.neutral900};
  border-radius: 8px;
  padding: 0 18px;
  background: ${(props) => props.theme.colors.neutral100};
  div {
    height: 56px;
  }
`;

export const CollapsableAbsolute = styled.div<{
  isOpen: boolean;
  height?: any;
}>`
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  max-height: ${(props) => (props.isOpen ? `${props.height}` : '0')};
  overflow: hidden;
  transition: all 500ms;
  margin-bottom: ${(props) => (props.isOpen ? '20px' : '0')};
  position: absolute;
  right: 0;
  left: 0;
  top: 76px;
  z-index: 1;
`;
